// Auto-generated (azurerm keys) from 79 unique Azure resources (cleaned deprecated)
export const azureTop100Whitelist = [
  "azurerm_api_management",
  "azurerm_app_configuration",
  "azurerm_app_service_certificate",
  "azurerm_app_service_environment_v3",
  "azurerm_app_service_plan",
  "azurerm_application_gateway",
  "azurerm_application_insights",
  "azurerm_automation_account",
  "azurerm_availability_set",
  "azurerm_active_directory_domain_service",
  "azurerm_arc_machine",
  "azurerm_bastion_host",
  "azurerm_bot_service_azure_bot",
  "azurerm_redis_cache",
  "azurerm_search_service",
  "azurerm_container_group",
  "azurerm_container_registry",
  "azurerm_cosmosdb_account",
  "azurerm_postgresql_server",
  "azurerm_kusto_cluster",
  "azurerm_data_factory",
  "azurerm_databricks_workspace",
  "azurerm_dns_zone",
  "azurerm_firewall",
  "azurerm_cdn_frontdoor_profile",
  "azurerm_function_app",
  "azurerm_iotcentral_application",
  "azurerm_iothub",
  "azurerm_key_vault",
  "azurerm_kubernetes_cluster",
  "azurerm_lb",
  "azurerm_logic_app_workflow",
  "azurerm_machine_learning_workspace",
  "azurerm_managed_disk",
  "azurerm_user_assigned_identity",
  "azurerm_mssql_managed_instance",
  "azurerm_monitor_action_group",
  "azurerm_network_interface",
  "azurerm_network_security_group",
  "azurerm_policy_assignment",
  "azurerm_private_endpoint",
  "azurerm_public_ip",
  "azurerm_recovery_services_vault",
  "azurerm_resource_group",
  "azurerm_role_assignment",
  "azurerm_sentinel_log_analytics_workspace_onboarding",
  "azurerm_servicebus_namespace",
  "azurerm_service_fabric_cluster",
  "azurerm_signalr_service",
  "azurerm_site_recovery_fabric",
  "azurerm_mssql_database",
  "azurerm_mssql_server",
  "azurerm_storage_account",
  "azurerm_stream_analytics_job",
  "azurerm_synapse_workspace",
  "azurerm_synapse_sql_pool",
  "azurerm_synapse_spark_pool",
  "azurerm_traffic_manager_profile",
  "azurerm_linux_virtual_machine",
  "azurerm_virtual_machine",
  "azurerm_windows_virtual_machine",
  "azurerm_orchestrated_virtual_machine_scale_set",
  "azurerm_virtual_network",
  "azurerm_subnet",
  "azurerm_vpn_gateway",
  "azurerm_batch_account",
  "azurerm_cdn_profile",
  "azurerm_cognitive_account",
  "azurerm_container_app",
  "azurerm_cdn_endpoint",
  "azurerm_cosmosdb_sql_database",
  "azurerm_eventgrid_domain",
  "azurerm_eventgrid_event_subscription",
  "azurerm_eventgrid_topic",
  "azurerm_eventhub_namespace",
  "azurerm_express_route_circuit",
  "azurerm_frontdoor",
  "azurerm_key_vault_certificate",
  "azurerm_key_vault_key",
  "azurerm_key_vault_secret",
  "azurerm_logic_app_standard",
  "azurerm_storage_blob",
] as const;

export type AzureTop100Tf = (typeof azureTop100Whitelist)[number];